module.exports = __webpack_public_path__ + "Rochester-Regular.db298adb72f998df4b62.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/assets/font/Rochester-Regular.ttf
// module id = ../../../../../src/assets/font/Rochester-Regular.ttf
// module chunks = styles